import React from 'react';
import { Input as InputNew } from './Input';
import { convertOldInputProps } from './converter.old';
import type { OldInputProps } from './converter.old';

export type InputProps = OldInputProps;

export const Input = React.forwardRef<HTMLInputElement, InputProps>((props, ref) => (
  <InputNew {...convertOldInputProps(props)} ref={ref} />
));
